import { render, staticRenderFns } from "./general-settings-view.vue?vue&type=template&id=0f2890d9&scoped=true"
import script from "./general-settings-view.vue?vue&type=script&lang=js"
export * from "./general-settings-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2890d9",
  null
  
)

export default component.exports